<script setup>
const { options, darkTheme, disabled } = defineProps({
  options: {
    type: Array,
    required: true
  },
  darkTheme: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const model = defineModel({ type: String })
</script>

<template>
  <div class="flex items-center gap-2">
    <label
      v-for="option in options"
      :key="option.id"
      :for="`radio-${option.id}`"
      class="inline-flex items-center justify-center relative transition-all rounded-lg py-2.5 font-branding"
      :class="[
        darkTheme ? 
          model === option.id ? 'bg-gray-900 text-white font-normal' : 'border border-gray-900 text-gray-900'
        : 
          model === option.id ? 'bg-white text-gray-900 font-normal' : 'border border-white text-white',
        disabled ? 'opacity-70 grayscale cursor-not-allowed' : 'cursor-pointer',
      ]"
    >
      <input
        :id="`radio-${option.id}`"
        v-model="model"
        :disabled="disabled"
        type="radio"
        :value="option.id"
        class="absolute opacity-0 cursor-pointer"
      >
      <div>
        {{ option.label }}
      </div>
    </label>
  </div>
</template>
